import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PreviousPhaseDetail } from '../../models/previous-phase-detail';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ChangeManagementConstant } from '../../constants/changeManagementConstants';
import { ChangeControlDetailsService } from '../../services/change-control-details.service';
import { ChangeControlDisplayDetails } from '../../models/change-control-display-details';
import { ChangeControlPersistenceService } from '../../services/change-control-persistence.service';

@Component({
  selector: 'app-change-control-previous-phase-modal',
  templateUrl: './change-control-previous-phase-modal.component.html',
  styleUrls: ['./change-control-previous-phase-modal.component.scss']
})
export class ChangeControlPreviousPhaseModalComponent implements OnInit {
  @Input() changeControlNumber: any;
  @Output() isReasonForChangeModalVisible = new EventEmitter<boolean>();
  @Output() updatedChangeControlData = new EventEmitter<ChangeControlDisplayDetails>();
  @Input() requiredModalHeader: string = '';
  changeControlPreviousphase!: PreviousPhaseDetail;
  previousPhase!: number;
  reasonForChange!: string;
  display: boolean = true;
  valueField: string = 'value';
  labelField: string = 'name';
  changeControlBindData: any = [];
  chanecontrolPhasesData: any = [];
  mandatoryFields = this.getDefaultMandatoryFields();
  errorMessages: string[] = [];

  selectedActionItem: string[] = [];

  constructor(private router: Router, private changeControlDetailsService: ChangeControlDetailsService, private messageService: MessageService,
    private changeControlPersistenceService: ChangeControlPersistenceService
  ) {
  }
  
  ngOnInit(): void {
    this.initialize();
  }


  initialize() {   
    this.changeControlDetailsService.getValidPreviousPhasesForChangeControl(this.changeControlNumber).subscribe(
      serviceData => {
        this.chanecontrolPhasesData = serviceData;
      }
    );
  }


  reloadChangeControlDetail() {
    this.isReasonForChangeModalVisible.emit(true);
  }

  getDefaultMandatoryFields() {
    return {
      previousPhase: false,
      reasonForChange: false,
    }
  }

  saveReasonForChange() {
    this.errorMessages=[];
     this.validatePreviousPhaseModalControls();
    if (this.errorMessages.length === 0) {
       
      // Update selection item on change of selection
      this.changeControlPersistenceService.selectedActionitem$.subscribe((resp) => {
        // Going with for each loop instead of map to as action item number is a nullable field
        let selectedItems = new Set<string>();
        resp.forEach((key) => {
          if(key.actionItemNumber != null)
            selectedItems.add(key.actionItemNumber);
        })
        this.selectedActionItem = Array.from(selectedItems);
      });
      

      this.changeControlPreviousphase = {
        changeControlNumber: this.changeControlNumber,
        reason: this.reasonForChange,
        phase: this.previousPhase,
        actionItemIds: this.selectedActionItem
      }
      this.changeControlDetailsService.MoveChangeControlToPreviousPhase(this.changeControlPreviousphase)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: ChangeManagementConstant.Severity_Err,
            summary: `${err.error}`,
          });
          return throwError(() => err);
        })
      )  
      .subscribe(
          (serviceData) => {
            this.display = false;
            this.updatedChangeControlData.emit(serviceData);
            this.changeControlPersistenceService.actionPlanDataUpdated.next(true);
            this.changeControlPersistenceService.updateChangeControlView();
            this.messageService.add({
              severity: ChangeManagementConstant.Severity_Info,
              summary: `${ChangeManagementConstant.MoveToPreviousPhase_Success}`
            });
        });
      }
    }

    private validatePreviousPhaseModalControls(){
      const isWhitespace = (this.reasonForChange || '').trim().length === 0;
      if(this.reasonForChange === "" || this.reasonForChange === undefined || this.reasonForChange?isWhitespace:null){
            this.mandatoryFields.reasonForChange = true;
            this.errorMessages.push(ChangeManagementConstant.PreviousPhase_ReasonForChange_Required); 
      }
      if(this.previousPhase === null|| this.previousPhase === undefined){
      this.mandatoryFields.previousPhase = true;
      this.errorMessages.push(ChangeManagementConstant.PreviousPhase_Phase_Required);        
      }
    }

}
